import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PlayerTimeline extends Component {


    state = {
        time: 0,
        isOn: false,
        start: 0,
        currentTimelineElement: null
    };

    componentWillMount() {
        this.stopTimer();
    }

    startTimer = () => {
        this.setState({
            isOn: true,
            start: Date.now() - this.state.time
        })

        this.timer = setInterval(() => this.onTick(), 1000);


        // if (this.db !== undefined)
        //     this.db.child("is_playing").set(1);
    }

    stopTimer = () => {
        this.setState({ isOn: false })
        clearInterval(this.timer)
        this.timer = null;


        // if (this.db !== undefined)
        //     this.db.child("is_playing").set(0);
    }


    resetTimer = () => {
        this.setState({ time: 0, isOn: false });

        if (this.db !== undefined)
            this.db.child("is_playing").set(0);
    }

    onTick = () => {
        this.setState({
            time: this.state.time + 1
        })

        if (this.state.contentjson === null) {
            return;
        }

        // const currentTimeline = this.getCurrentTimeline();
        // const currentTimelineElement = this.getCurrentTimelineElement(currentTimeline);

        // this.setState({ currentTimelineElement: currentTimelineElement });

        // if (this.layoutRef.current) {
        //     this.layoutRef.current.onTick();
        // }
    }

    render() {
        const { children = () => { }, backgroundColor = "black", style = {} } = this.props;

        if (!this.state.isOn) {
            return null;
        }

        return (
            <div style={{ width: "100%", height: "100%", backgroundColor: backgroundColor, ...style }}>
                {children(this.state.time)}
            </div>
        )
    }
}

PlayerTimeline.propTypes = {
    children: PropTypes.func.isRequired
}
export default PlayerTimeline